import React from 'react'
import { useTranslation } from 'react-i18next'
import { ColorHandler } from 'src/utils/style.utils'
import { RootState } from 'src/store/store'
import { ResetDataPropsType } from 'src/views/Account/Reset'
import { COLOR } from 'src/constants/colors'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import Span from 'src/components/atomic/atom/Span'
import Input from 'src/components/atomic/atom/Input'
import Svg from 'src/components/atomic/atom/Svg'
import ErrTextBox from 'src/components/atomic/Molecules/ErrTextBox'
import Button from 'src/components/atomic/atom/Button'

const ResetTemplate = (props: { data: ResetDataPropsType }) => {
  const { ResetBtnHandler, ResetItemsList } = props.data
  const { t } = useTranslation()
  const { CreatePin, ConfirmPin } = useAppSelector((state: RootState) => state.ResetPage)
  const { errText } = useAppSelector((state: RootState) => state.common)
  return (
    <>
      {ResetItemsList.map((element, index: number) => (
        <React.Fragment key={index}>
          <Span $text_align={'left'} option={'small'} color={COLOR.black60} $margin={'0 0 8px 0'}>
            {element.text}
          </Span>
          <Input
            autoFocus={element.autoFocus}
            value={element.state}
            option={element.inputOption}
            type={element.type}
            $border={element.border}
          />
          <Svg name={element.svgName} onClick={element.dispatch} style={element.svgStyle} />
        </React.Fragment>
      ))}
      <ErrTextBox>{errText}</ErrTextBox>
      <Button
        option={'bigDefault'}
        disabled={CreatePin?.length + ConfirmPin?.length !== 12}
        $bgColor={ColorHandler(CreatePin?.length + ConfirmPin?.length === 12, 'brand_black10')}
        onClick={ResetBtnHandler}
      >
        <Span
          option={'medium_bold'}
          color={ColorHandler(CreatePin?.length + ConfirmPin?.length === 12, 'white_black30')}
        >
          {t('BUTTON.PIN_RESET', { defaultValue: 'Reset' })}
        </Span>
      </Button>
    </>
  )
}

export default ResetTemplate
